import { RouterLink, route } from '../router.js';
import { THEMES, currentTheme, applyTheme } from '../theme.js';
import { AgentSection } from './AgentSection.js';
import { ProjectsSettings } from './ProjectsSettings.js';
import { Limits } from './Limits.js';

// Настройки: агент и оформление.
//
// У каждого раздела свой адрес — ссылку на любой можно дать как есть. Агент
// идёт первым и открывается по умолчанию: за ним ходят разбираться, когда
// что-то не работает, а тему выбирают один раз и забывают.

export const Settings = {
  components: { RouterLink, AgentSection, ProjectsSettings, Limits },
  data() { return { themes: THEMES, theme: currentTheme() }; },
  computed: {
    // У каждого раздела свой адрес, и агент — тот, к которому ведут голые
    // /settings и старый /agent: за ним ходят разбираться, тему выбирают
    // однажды.
    tab() {
      if (/\/theme/.test(route.path)) return 'theme';
      if (/\/limits/.test(route.path)) return 'limits';
      if (/\/projects/.test(route.path)) return 'projects';
      return 'agent';
    },
  },
  methods: {
    pick(id) { this.theme = applyTheme(id); },
  },
  template: `
    <div class="page narrow">
      <p class="crumbs"><router-link to="/projects">Проекты</router-link> · Настройки</p>
      <h1>Настройки</h1>

      <nav class="tabs">
        <router-link to="/settings/agent"><button :class="{ on: tab === 'agent' }">Агент</button></router-link>
        <router-link to="/settings/projects"><button :class="{ on: tab === 'projects' }">Проекты</button></router-link>
        <router-link to="/settings/theme"><button :class="{ on: tab === 'theme' }">Выбор темы</button></router-link>
        <router-link to="/settings/limits"><button :class="{ on: tab === 'limits' }">Лимиты</button></router-link>
      </nav>

      <template v-if="tab === 'theme'">
        <div class="card">
          <p class="note" style="margin-top:0">
            Выбор живёт на этом устройстве: с телефона и с ноутбука можно
            держать разное.
          </p>
          <div class="places">
            <label class="place" v-for="t in themes" :key="t.id" :class="{ on: theme === t.id }">
              <input type="radio" name="theme" :value="t.id" v-model="theme" @change="pick(t.id)">
              <span>
                <b>{{ t.name }}</b>
                <i>{{ t.hint }}</i>
              </span>
            </label>
          </div>
        </div>
      </template>

      <Limits v-else-if="tab === 'limits'"></Limits>
      <ProjectsSettings v-else-if="tab === 'projects'"></ProjectsSettings>

      <AgentSection v-else></AgentSection>
    </div>`,
};
